import { axiosGet } from '../util/api'
import { Dispatch } from 'redux'
import { State } from '../reducers'
import {
    SET_SMART_BID_SETTINGS,
    SET_SMART_BID_SETTINGS_LOADED,
    SET_SMART_BID_SETTINGS_LOADING,
    SetSmartBidSettingsAction,
    SetSmartBidSettingsLoadedAction,
    SetSmartBidSettingsLoadingAction,
} from '../constants/reducers/smart_bid_settings'

const setLoading = (loading: boolean): SetSmartBidSettingsLoadingAction => ({
    type: SET_SMART_BID_SETTINGS_LOADING,
    loading,
    receivedAt: Date.now(),
})

const setLoaded = (loaded: boolean): SetSmartBidSettingsLoadedAction => ({
    type: SET_SMART_BID_SETTINGS_LOADED,
    loaded,
    receivedAt: Date.now(),
})

const setSmartBidSettings = (
    smartBidSettings: Models.SmartBidSetting[],
): SetSmartBidSettingsAction => ({
    type: SET_SMART_BID_SETTINGS,
    smartBidSettings,
    receivedAt: Date.now(),
})

export function fetchSmartBidSettingsIfNeeded() {
    return (dispatch: Dispatch<any>, getState: () => State) => {
        const state = getState()
        if (state.smartBidSettings.loaded == false && state.smartBidSettings.loading == false) {
            return dispatch(fetchSmartBidSettings())
        } else {
            return Promise.resolve()
        }
    }
}

export function fetchSmartBidSettings() {
    return (dispatch: Dispatch<any>) => {
        dispatch(setLoading(true))
        axiosGet('smart-bid-settings')
            .then((res) => {
                dispatch(setSmartBidSettings(res.data))
                dispatch(setLoading(false))
                dispatch(setLoaded(true))
            })
            .catch((res) => {
                console.log('caught error', res)
                dispatch(setLoading(false))
            })
    }
}
